import React from "react";
import PropTypes from "prop-types";

import { Subcategory } from "@menu/components";

const Category = (props) => {
  return (
    <li>
      <input 
        id={"category-" + props.section.id} 
        name="category" 
        type="radio"
        className="nav-main-input"
        role="button"
        checked={props.selected}
        readOnly
      />
      <label
        tabIndex="0"
        className={`nav-main ${props.selected ? 'selected-category-label' : ''}`}
        htmlFor={"category-" + props.section.id}
        onClick={props.onClick}
      >
        {props.section.name}
      </label>
      {props.selected &&
        <Subcategory
          categories={props.section.menu_content}
          parentId={props.section.id}
          mobile={props.mobile}
          clickSection={props.clickSection}
        />
      }
    </li>
  );
}

Category.propTypes = {
  selected: PropTypes.bool.isRequired,
  section: PropTypes.any.isRequired,
  onClick: PropTypes.func.isRequired,
  clickSection: PropTypes.func.isRequired,
  mobile: PropTypes.bool.isRequired
}

export default Category;
